<template>
  <div
    class="d-flex-row space-between lg-row-to-col align-start"
    style="margin-top: 24px"
  >
    <div
      class="d-flex-column justify-start align-start gap-24 flex-65 flex-lg-10"
    >
      <BoosterDashboardBanner
        :username="boosterData?.username"
        :avatar="boosterData?.avatar"
        :bio="boosterData?.bio"
        :languages="boosterData?.languages"
        :reviews-score="boosterData?.reviews_score"
        :reviews-count="boosterData?.reviews_count"
        :platforms="boosterData?.platforms"
        :booster-rank="boosterData?.rank?.title"
        :onlineStatus="boosterData?.online"
        :id="boosterData?.id"
        :first-game="firstGame"
      />
      <div class="d-flex-column justify-start align-start d-hide lg-show">
        <div class="d-flex-row space-between">
          <h6 class="t-white title-h5 font-family-1">
            {{ $t("booster_profile.testimonials") }}
          </h6>
        </div>

        <TestimonialCard :testimonials="boosterData?.reviews" />

        <h6 class="t-white title-h5 font-family-1" style="margin-top: 20px">
          {{ $t("dashboard.achievements") }}
        </h6>
        <div class="d-flex-column justify-start align-start">
          <AchievementCard
            v-for="achivemenet in boosterData?.achievements"
            :key="achivemenet"
            :achievement-data="achivemenet"
          />
        </div>
      </div>

      <div class="d-flex-column justify-start align-start">
        <h5 class="t-white font-family-1 title-h5 f-w-600">
          {{ $t("booster_profile.games") }}
        </h5>

        <BoosterProfileGameCard
          v-for="game in boosterData?.games"
          :key="game"
          :image="game.image"
          :game-title="game.slug"
          :rank="game.user_ranks[0]"
          :heroes="game?.user_heroes"
          :roles="game?.user_roles"
          :regions="game?.user_servers"
          :isPrimary="game?.is_primary === 1"
          :game-id="game?.id"
        />
      </div>
    </div>

    <div
      class="flex-3 flex-lg-10 d-flex-column justify-start align-start lg-hide"
    >
      <div class="d-flex-row space-between">
        <h6 class="t-white title-h6 font-family-1">
          {{ $t("booster_profile.testimonials") }}
        </h6>
      </div>

      <TestimonialCard :testimonials="boosterData?.reviews" />

      <h6 class="t-white title-h6 font-family-1" style="margin-top: 20px">
        {{ $t("dashboard.achievements") }}
      </h6>
      <div class="d-flex-column justify-start align-start">
        <AchievementCard
          v-for="achivemenet in boosterData?.achievements"
          :key="achivemenet"
          :achievement-data="achivemenet"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import TestimonialCard from "~/components/cards/TestimonialCard.vue";
import AchievementCard from "~/components/cards/AchievementCard.vue";
import BoosterProfileGameCard from "~/components/cards/BoosterProfileGameCard.vue";
import BoosterDashboardBanner from "~/components/banners/BoosterDashboardBanner.vue";
import { ref, computed } from "vue";
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "boosters-game-page",
  },
});

const router = useRouter();
const route = router.currentRoute;
const { locale, setLocale } = useI18n();
const { getLocale } = useFunctions();
const localePath = useLocalePath();
const boosterData = ref({
  games: [],
  achievements: [],
});

if (locale.value !== "en") {
  setLocale("en");
}

const firstGame = computed(() => {
  if (boosterData.value?.games?.length > 0) {
    return boosterData.value?.games[0];
  }
  return null;
});

const { data: response, error } = await useApiFetch(
  `/api/get-single-booster/${route.value.params?.boosterId}`,
  {
    method: "POST",
    fetchKey: "get-single-booster",
    body: {
      locale: getLocale(),
      params: [
        "games",
        "platforms",
        "languages",
        "regions",
        "roles",
        "rank",
        "reviews",
        "reviews_score_and_count",
        "bio",
        "achievements",
        "game_ranks",
        "game_roles",
        "game_servers",
        "game_heroes",
      ],
      reviews_count: 10,
    },
  }
);
if (response.value?.data) {
  boosterData.value = response.value?.data;
}
if (error.value?.data) {
  await navigateTo(localePath("/"), {
    redirectCode: 301,
  });
}
</script>
